import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Tooltip, message } from "antd";
import {
  MailOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
  EyeOutlined,
  LockOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import OTPInput from "otp-input-react";
import { connect } from "react-redux";
import { onLanguageChange } from "../../Redux/Actions/LanguageActions";
import {
  ForgetPasswordUser,
  OTPVerification,
  ChangePassword,
} from "../../Utils/APIManager/APIConstants";
import { APIRequest } from "../../Utils/APIManager/APIRequest";
import {
  STR_Tam_Email,
  STR_Email,
  STR_Tam_SendOtp,
  STR_SendOtp,
  STR_Tam_OtpVerify,
  STR_OtpVerify,
  STR_Tam_VerifyOtp,
  STR_VerifyOtp,
  STR_Tam_SetNewPassword,
  STR_SetNewPassword,
  STR_Tam_ChangePassword,
  STR_ChangePassword,
  STR_Tam_EmailEmpty,
  STR_EmailEmpty,
  STR_Tam_EmailValid,
  STR_EmailValid,
  STR_Tam_PasswordEmpty,
  STR_PasswordEmpty,
  STR_Tam_Confirm_PasswordEmpty,
  STR_Confirm_PasswordEmpty,
  STR_Tam_PasswordValid,
  STR_PasswordValid,
  STR_PasswordValidation,
  STR_TAM_PasswordValidation,
  STR_Tam_Password,
  STR_Tam_NewPasswordEmpty,
  STR_NewPasswordEmpty,
  STR_TAM_Password_Requirement,
  STR_Password_Requirement,
  STR_Tam_SamePasswordValid,
  STR_SamePasswordValid,
} from "../../Config.js/Strings";
import backgroundImage from "../../assets/background_logout.jpg";

const ForgetPasswordModal = ({ open, onClose, LanguageReducer }) => {
  const { isTamil } = LanguageReducer;
  const [step, setStep] = useState("email");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const [error, setError] = useState("");

  useEffect(() => {
    if (step === "otp" && timer > 0) {
      const countdown = setInterval(() => setTimer((t) => t - 1), 1000);
      return () => clearInterval(countdown);
    }
  }, [step, timer]);

  const resetAll = () => {
    setStep("email");
    setEmail("");
    setOtp("");
    setPassword("");
    setConfirm("");
    setTimer(30);
  };

  const handleSendOTP = async () => {
    if (!email) {
      setError(isTamil ? STR_Tam_EmailEmpty : STR_EmailEmpty);
      return;
    }
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!pattern.test(email)) {
      setError(isTamil ? STR_Tam_EmailValid : STR_EmailValid);
      return;
    }
    setError("");

    setLoading(true);
    try {
      const res = await APIRequest.getPostService(ForgetPasswordUser, {
        email,
        language: isTamil ? "TAMIL" : "ENGLISH",
      });
      if (res.status) {
        message.success(res.message);
        setStep("otp");
        setTimer(30);
      } else message.error(res.message);
    } catch (err) {
      message.error(err.message || "Error sending OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (otp.length < 6)
      return message.error(
        isTamil ? "OTP ஐ முழுமையாக உள்ளிடவும்" : "Enter full 6-digit OTP"
      );

    setLoading(true);
    try {
      const res = await APIRequest.getPostService(
        OTPVerification,
        { verificationCode: otp },
        { "Accept-Language": isTamil ? "TAMIL" : "ENGLISH" }
      );
      if (res.status) {
        message.success(res.message);
        setStep("reset");
      } else message.error(res.message);
    } catch (err) {
      message.error(err.message || "Error verifying OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    // if (!password)
    //   return message.error(isTamil ? STR_Tam_PasswordEmpty : STR_PasswordEmpty);
    // if (!confirm)
    //   return message.error(
    //     isTamil ? STR_Tam_Confirm_PasswordEmpty : STR_Confirm_PasswordEmpty
    //   );
    // if (password !== confirm)
    //   return message.error(isTamil ? STR_Tam_PasswordValid : STR_PasswordValid);

    setLoading(true);
    try {
      const res = await APIRequest.getPostService(ChangePassword, {
        email,
        password,
        conform_password: confirm,
        language: isTamil ? "TAMIL" : "ENGLISH",
      });
      if (res.status) {
        message.success(res.message);
        onClose();
        resetAll();
      } else message.error(res.message);
    } catch (err) {
      message.error(err.message || "Error resetting password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={() => {
        onClose();
        resetAll();
      }}
      footer={null}
      centered
      width={700}
      className="login_popupmodal"
      bodyStyle={{
        padding: 0,
        borderRadius: "20px",
        overflow: "hidden",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "500px",
      }}
      destroyOnClose
    >
      <div className="forgetpassword-modal">
        <div className="account_recoveryform flex flex-col lg:flex-row items-center justify-center rounded-2xl backdrop-blur-md bg-opacity-50">
          {/* Left 3D Image Section */}
          <div className="hidden lg:flex w-1/2 justify-center items-center">
            {/* <img
            src={require("../../assets/login_character.png")}
            alt="Illustration"
            style={{
              width: "80%",
              height: "auto",
              objectFit: "contain",
            }}
          /> */}
          </div>

          {/* Right Form Section */}
          <div className="acct_recoveryform w-full lg:w-1/2 p-8">
            {step === "email" && (
              <>
                <h2 className="heading_textacct text-xl font-semibold mb-6 text-center">
                  {isTamil ? "கணக்கை மீட்டெடுக்க" : "Account Recovery"}
                </h2>
                <div
                  style={{
                    position: "relative",
                    width: "110%",
                    marginLeft: "-25px",
                    marginBottom: "20px",
                  }}
                >
                  <Input
                    prefix={<MailOutlined />}
                    placeholder={isTamil ? STR_Tam_Email : STR_Email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setError(""); // clear message when typing
                    }}
                    value={email}
                    status={error ? "error" : ""}
                    style={{
                      borderRadius: "10px",
                      height: "45px",
                    }}
                  />
                  {error && (
                    <p
                      style={{
                        color: "red",
                        fontSize: "13px",
                        marginTop: "5px",
                        marginBottom: "10px",
                      }}
                    >
                      {error}
                    </p>
                  )}
                </div>
                <Button
                  type="primary"
                  block
                  loading={loading}
                  onClick={handleSendOTP}
                  style={{
                    background: "#0FA6C9",
                    borderRadius: "8px",
                    height: "45px",
                    width: "90%",
                    marginBottom: "10px",
                  }}
                >
                  {isTamil ? STR_Tam_SendOtp : STR_SendOtp}
                </Button>
                <div
                  className="text-center mt-3 "
                  style={{ marginRight: "30px" }}
                >
                  <span className="AccountRecoverySignIn underline">
                    {isTamil ? "அல்லது" : "or"}{" "}
                    <a
                      href="#"
                      onClick={() => {
                        onClose();
                        resetAll();
                        window.dispatchEvent(new Event("openLoginPopup"));
                      }}
                      className="AccountRecoverySignIn underline"
                    >
                      {isTamil ? "உள்ளே செல்ல" : "Sign In"}
                    </a>
                  </span>
                </div>
              </>
            )}
            {step === "otp" && (
              <>
                <h2 className="text-xl font-semibold mb-6 text-center">
                  {isTamil ? STR_Tam_OtpVerify : STR_OtpVerify}
                </h2>

                {/* OTP Input Boxes */}
                <div className="flex justify-center mb-4">
                  <OTPInput
                    value={otp}
                    onChange={(v) => /^[0-9]*$/.test(v) && setOtp(v)}
                    OTPLength={6}
                    otpType="number"
                    inputClassName="otp-input-antd"
                  />
                </div>
                {/* OTP Timer + Resend Logic */}
                <div className="text-center mt-2" style={{ fontSize: "14px" }}>
                  {/* Line 1 */}
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#555",
                      fontWeight: "600",
                    }}
                  >
                    {isTamil
                      ? "ஒருமுறைக் கடவுச்சொல் கிடைக்கவில்லையா?"
                      : "Didn’t receive OTP?"}
                  </div>

                  {/* Line 2 */}
                  <div style={{ marginTop: "4px" }}>
                    {timer > 0 ? (
                      <span style={{ color: "#0FA6C9" }}>
                        {isTamil ? "மீண்டும் அனுப்பவும்: " : "Resend OTP:"}
                        <b>{timer}s</b>
                      </span>
                    ) : (
                      // Timer finished → only show text "Resend OTP (0s)"
                      <span
                        onClick={() => {
                          setTimer(30);
                          setOtp("");
                          handleSendOTP();
                        }}
                        style={{
                          color: "#0FA6C9",
                          fontWeight: "600",
                          cursor: "pointer",
                        }}
                      >
                        {isTamil ? "மீண்டும் அனுப்பவும்" : "Resend OTP"}
                      </span>
                    )}
                  </div>
                </div>
                <Button
                  type="primary"
                  block
                  loading={loading}
                  onClick={handleVerifyOTP}
                  style={{
                    background: "#0FA6C9",
                    borderRadius: "8px",
                    height: "45px",
                    marginTop: "15px",
                  }}
                >
                  {isTamil ? STR_Tam_VerifyOtp : STR_VerifyOtp}
                </Button>
              </>
            )}
            {step === "reset" && (
              <>
                <h2 className="text-xl font-semibold mb-6 text-center">
                  {isTamil ? STR_Tam_SetNewPassword : STR_SetNewPassword}
                </h2>

                <Form layout="vertical" onFinish={handleResetPassword}>
                  {/* NEW PASSWORD — Same Style as Signup */}
                  <Form.Item
                    name="password"
                    className="password_form"
                    rules={[
                      {
                        required: true,
                        message: isTamil
                          ? STR_Tam_PasswordEmpty
                          : STR_PasswordEmpty,
                      },
                      {
                        min: 8,
                        message: isTamil
                          ? STR_TAM_PasswordValidation
                          : STR_PasswordValidation,
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder={isTamil ? STR_Tam_Password : "Password"}
                      prefix={
                        <LockOutlined
                          style={{ color: "#737575ff", width: "100%" }}
                        />
                      }
                      iconRender={(visible) =>
                        visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                      }
                      onChange={(e) => setPassword(e.target.value)}
                      addonAfter={
                        <Tooltip
                          title={
                            <div>
                              <p>
                                1.{" "}
                                {isTamil
                                  ? STR_Tam_NewPasswordEmpty
                                  : STR_NewPasswordEmpty}
                              </p>
                              <p>
                                2.{" "}
                                {isTamil
                                  ? STR_TAM_PasswordValidation
                                  : STR_PasswordValidation}
                              </p>
                              <p>
                                3.{" "}
                                {isTamil
                                  ? STR_TAM_Password_Requirement
                                  : STR_Password_Requirement}
                              </p>
                            </div>
                          }
                        >
                          <InfoCircleOutlined
                            style={{ color: "#10add1", fontSize: "15px" }}
                          />
                        </Tooltip>
                      }
                      style={{
                        borderRadius: "15px",
                        height: "40px",
                        fontSize: "12px",
                      }}
                    />
                  </Form.Item>

                  {/* CONFIRM PASSWORD — Same style as Signup */}
                  <Form.Item
                    name="conform_password"
                    dependencies={["password"]}
                    rules={[
                      {
                        required: true,
                        message: isTamil
                          ? STR_Tam_Confirm_PasswordEmpty
                          : STR_Confirm_PasswordEmpty,
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue("password") === value) {
                            return Promise.resolve();
                          }
                          return Promise.reject(
                            new Error(
                              isTamil
                                ? STR_Tam_SamePasswordValid
                                : STR_SamePasswordValid
                            )
                          );
                        },
                      }),
                    ]}
                  >
                    <Input.Password
                      placeholder={
                        isTamil
                          ? STR_Tam_Confirm_PasswordEmpty
                          : STR_Confirm_PasswordEmpty
                      }
                      prefix={
                        <LockOutlined
                          style={{ color: "#737575ff", width: "100%" }}
                        />
                      }
                      iconRender={(visible) =>
                        visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                      }
                      onChange={(e) => setConfirm(e.target.value)}
                      style={{
                        borderRadius: "12px",
                        height: "40px",
                        fontSize: "12px",
                      }}
                    />
                  </Form.Item>

                  <Button
                    type="primary"
                    block
                    loading={loading}
                    // onClick={handleResetPassword}
                    htmlType="submit"
                    style={{
                      background: "#0FA6C9",
                      borderRadius: "8px",
                      height: "45px",
                      marginTop: "10px",
                    }}
                  >
                    {isTamil ? STR_Tam_ChangePassword : STR_ChangePassword}
                  </Button>
                </Form>
              </>
            )}
          </div>
        </div>
      </div>
      {/* OTP input styling */}
      <style>
        {`
          .otp-input-antd {
           width: 50px;
           height: 50px;
           gap: 2px;
           margin: 0 6px;
           font-size: 18px;
           text-align: center;
           border: 1px solid #0FA6C9; /* Blue border */
           border-radius: 5px;
           background-color: #e6f7ff; /* Soft blue background */
           font-weight: 600;
           transition: all 0.3s ease;
           }

          .otp-input-antd:focus {
            background-color: #ffffff;
          //  box-shadow: 0 0 8px rgba(15, 166, 201, 0.4);
           outline: none;
           }
        `}
      </style>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  LanguageReducer: state.LanguageReducer,
});

export default connect(mapStateToProps)(ForgetPasswordModal);
